// extracted by mini-css-extract-plugin
export default {"container":"_2alWXjKrE61E1g93drTSWo"};